import { postData } from "./api-utils";
import { endpoints } from "../config";
import axios from "axios";

const baseEndpoint = endpoints.login;

const setToken = (token) => {
  localStorage.setItem("jwt", token);
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};
const removeToken = () => {
  localStorage.removeItem("jwt");
  axios.defaults.headers.common["Authorization"] = null;
};
const getToken = () => {
  return localStorage.getItem("jwt");
};
const sendLoginData = (login, password) => {
  return postData(baseEndpoint, { login, password });
};

export { setToken, removeToken, sendLoginData, getToken };
